import { ref, onMounted } from 'vue'
import { GeneralWrapper } from '@/wrappers'
import type { FormStatistics } from '@/interfaces'

export function useFormStats() {

    const generalWrapper = new GeneralWrapper();

    const isLoaded = ref<boolean>(false);
    const formStatistics = ref<FormStatistics[]>([]);

    onMounted(() => generalWrapper.getFormStatistics().then(data => {
            formStatistics.value = data;
            isLoaded.value = !isLoaded.value;
    }));

    return {
        isLoaded,
        formStatistics
    };
}